<template>
  <contact-page-content
    class="max-w-[700px]"
    :title="$t('growth.contact_page.title')"
  >
    <template #subtitle>
      <p class="text-balance">
        {{ $t("growth.contact_page.subtitle") }}
      </p>

      <contact-page-team-list class="mt-8 hidden lg:block" />
    </template>
  </contact-page-content>
</template>

<script setup lang="ts">
import ContactPageTeamList from "~/pages/contact/_includes/components/contact-page-team-list.vue";
import ContactPageContent from "~/pages/contact/_includes/components/content/contact-page-content.vue";
</script>
